import Vue from 'vue'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import router from './router'
import store from './store' 
import "./validation-rules/rules";
import CoolLightBox from 'vue-cool-lightbox'
import App from './AppNetherlands.vue'
import Cart from './components/vue-material-design-icons/Cart';
import Selected from './components/vue-material-design-icons/Selected';
import ArrowRight from './components/vue-material-design-icons/ArrowRight.vue';
import QrcodeScan from './components/vue-material-design-icons/QrcodeScan';
import SearchWeb from './components/vue-material-design-icons/SearchWeb';
import MobileFilter from './components/vue-material-design-icons/MobileFilter';
import CloseCircleOutline from './components/vue-material-design-icons/CloseCircleOutline';
import { Loading,Collapse, CollapseItem } from 'element-ui'
import ThatsNotify from './util/Notify.js'
import 'sweetalert2/src/sweetalert2.scss'
import VueSweetalert2 from 'vue-sweetalert2';
import { utils} from './helpers/utils'
import { initializeApp } from './setup';
initializeApp(store)
Vue.use(CoolLightBox)
console.log("store",store)
const isDev = process.env.NODE_ENV
console.log("isDev",isDev)
Vue.component('close-icon', CloseCircleOutline);
Vue.component('qrcode-scan', QrcodeScan);
Vue.component('search-web', SearchWeb);
Vue.component('filter-menu', MobileFilter);
Vue.component('cart-icon', Cart);
Vue.component('selected-icon', Selected);
Vue.component('arrow-right', ArrowRight);
Vue.component('ElCollapse', Collapse)
Vue.component('ElCollapseItem', CollapseItem )
Vue.prototype.$eventBus = new Vue();
Vue.use(Loading.directive)
Vue.use(ThatsNotify)
Vue.use(VueSweetalert2);
const plugin = {
  install() {
    Vue.utils = utils
    Vue.prototype.$utils = utils
  }
}
Vue.use(plugin)
const x = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})
console.log(x)